import { createSlice } from "@reduxjs/toolkit";
import { lensProp, pathOr, pipe, set } from "ramda";
import * as PDFDetectedFieldsActions from "./actions";
import {clearAllDetectedFields} from "./actions";
import * as AppActions from "../app/actions";

export const initialState = {
  entities: {},
  ids: [],
  isShown: true,
};

const pdfDetectedFieldSlice = createSlice({
  name: "PDFDetectedField",
  initialState,
  reducers: {},
  extraReducers: {
    [AppActions.resetAppState.type]: (state, action) => {
      return initialState;
    },
    [PDFDetectedFieldsActions.clearAllDetectedFields.type]: (state, action) => {
      return pipe(
        set(lensProp("entities"), {}),
        set(lensProp("ids"), []),
      )(state);
    },

    [PDFDetectedFieldsActions.getPDFFieldsInfo.fulfilled.type]: (
      state,
      action
    ) => {
      return pipe(
        set(
          lensProp("entities"),
          pathOr({}, ["payload", "entities", "detectedFields"], action)
        ),
        set(lensProp("ids"), pathOr([], ["payload", "result"], action))
      )(state);
    },
    [PDFDetectedFieldsActions.setIsShown.type]: (state, action) => {
      return pipe(
        set(lensProp("isShown"), pathOr(false, ["payload", "value"], action))
      )(state);
    },
  },
});

export const { actions, reducer, name: sliceKey } = pdfDetectedFieldSlice;
